import OpenInNew from '@mui/icons-material/OpenInNew';
import MuiButton from '@mui/material/Button';
import classNames from 'classnames';
import {EntryFields} from 'contentful';

export type ButtonProps = {
  /** Button text */
  text?: string;
  /** Button type (semantic) */
  type: 'emphasized' | 'primary' | 'secondary' | 'white';
  /** Button size */
  size: 'small' | 'medium' | 'large';
  /** Button link href */
  href?: string;
  /** Whether Link is for internal pages, or external web page. (external links are opened in new tab) */
  isLinkExternal?: boolean;
  /** Aria label for the button */
  ariaLabel?: EntryFields.Text;
  /** Custom classname */
  className?: string;
  /** Click handler */
  onClick?: () => void;
};

const Button: React.FunctionComponent<ButtonProps> = ({
  text,
  type,
  size,
  href,
  isLinkExternal = false,
  ariaLabel,
  className,
  onClick,
}) => {
  const containedButtons = ['emphasized', 'primary', 'white'];

  return href ? (
    <MuiButton
      className={classNames(`button--color-${type}`, className)}
      variant={containedButtons.includes(type) ? 'contained' : 'outlined'}
      size={size}
      href={href}
      target={isLinkExternal ? '_blank' : undefined}
      rel={isLinkExternal ? 'noopener noreferrer' : undefined}
      aria-label={ariaLabel}
      endIcon={isLinkExternal ? <OpenInNew /> : undefined}
      disableElevation
      disableRipple
      onClick={onClick}
    >
      {text}
    </MuiButton>
  ) : null;
};

export default Button;
